/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */

/**
 * Which 401s mean "your session is over", and which do not.
 *
 * Everything the app calls goes through /api, but not everything behind /api authenticates the same
 * way. Services listed here validate our token against their own configuration, so a 401 from them
 * is a statement about that service, not about the session.
 *
 * This distinction is not theoretical. The GPS tracker API ran for a day with the production JWT
 * issuer while serving dev; it rejected every call with 401. Signing in worked, the vehicles page
 * then polled the tracker, and the response interceptor threw the user back to /login. The reported
 * symptom was "I cannot log in", which is nowhere near the fault.
 */
export const SEPARATELY_AUTHENTICATED_PREFIXES = [
  '/toll-tracker/',
];

/**
 * True when a 401 from this request must NOT end the session.
 * Accepts both the axios-relative form (`/toll-tracker/trackers`) and an absolute URL.
 */
export function isSeparatelyAuthenticated(url?: string): boolean {
  if (!url) return false;
  return SEPARATELY_AUTHENTICATED_PREFIXES.some(
    prefix => url.startsWith(prefix) || url.includes(`/api${prefix}`)
  );
}
